import { css } from '@emotion/react';
import { colors, alertColors, altColors } from './../common/arctechv2/theme';
const isDevelopment = process.env.NODE_ENV === 'development';
const isSandbox =
    process.env.REACT_APP_BETA_URI ===
    'https://beta-dashboard.sandbox.homedelivery.com.au';

const navColors = {
    navBlue: colors.gray800,
    sandboxNav: colors.purpleNav,
};

export const containerCss = css`
    button:hover {
        cursor: pointer;
    }

    width: 280px;
    flex-basis: 280px;
    flex: 0 0 auto;
    height: 100%;
    background: ${
        isSandbox || isDevelopment ? navColors.sandboxNav : navColors.navBlue
    };
    position: relative;
    transition: width 0.4s;
    transform: translate3d(0, 0, 0);
    z-index: 10;

    &.is-closed {
        width: 0;

        .wrap {
            transform: translateX(-100%);
        }
    }

    .nav-button {
        display: flex;
        align-items: center;
    }

    .nav-button--collapse-toggle {
        position: relative;
        > button {
            position: relative;
        }
        h5 {
            padding: 0 !important;
            position: relative;
        }
    }

    .sidemenu-trigger {
        background: ${
            isSandbox || isDevelopment
                ? navColors.sandboxNav
                : navColors.navBlue
        };
        font-size: 14px;
        padding: 10px 0;
        align-items: center;
        justify-content: center;
        width: 18px;
        height: 50px;
        left: 100%;
        z-index: 20;
        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;
        display: flex;
        color: ${colors.white};
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        border: 0;

        > i {
            transition:
                transform 0.3s,
                -webkit-transform 0.3s;
        }
    }

    .wrap {
        width: 280px;
        overflow-y: auto;
        height: 100%;
        opacity: 1;
        visibility: visible;
        transition: transform 0.4s;
        transition:
            transform 0.4s,
            -webkit-transform 0.4s;

        > .logo {
            padding: 20px;
            padding-bottom:0;

            > img {
                width: 100%;
                display: block;
            }
        }
    }

    .receival {
        button {
            span {
                font-size: 13px;
                font-weight: 600;
                color: ${colors.white};
            }
        }
    }

    .submenu {
        padding: 0 0 10px;
        border-bottom: 1px solid ${colors.charcoal};

        .collapse-toggle {
            position: absolute;
            top: 0;
            right: 0;
            text-align: right;
            z-index: 1;
            width: auto !important;
        }

        &:last-of-type {
            border-bottom: none;
        }

        &:empty {
            border-bottom: none;
            padding-bottom: 0;
        }

        &.no-padding-bottom {
            padding-bottom: 0;
        }

        h5 {
            padding: 10px 20px;
            font-weight: 700;
            font-size: 12px;
            text-transform: uppercase;
            color: ${colors.white};
            margin: 0;
        }

        a {
            &.active {
                button {
                    background: ${colors.gray700};
                }
            }
        }

        button {
            font-weight: 300;
            font-size: 14px;
            text-align: left;
            color: ${colors.gray};
            width: 100%;
            padding: 10px 20px;
            position: relative;
            border: 0;
            background: 0 0;
            outline: 0;

            &:hover {
                background: ${colors.gray700};
            }

            &::after {
                content: '\f054';
                display: inline-block;
                right: 15px;
                font-family: 'Font Awesome 5 Free', sans-serif;
                font-weight: 900;
                font-size: 8px;
                -moz-osx-font-smoothing: grayscale;
                -webkit-font-smoothing: antialiased;
                font-style: normal;
                font-variant: normal;
                text-rendering: auto;
                line-height: 1;
                color: ${colors.white};
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
            }

            i {
                width: 16px;
                margin: 0 12px 0 0;
                text-align: center;
                color: ${colors.white};
                vertical-align: top;
            }

            i.menu-tooltip {
                color: ${altColors.lightBlue};
            }
        }

        button[data-notifications-warning]::before {
            background: yellow !important;
        }

        button[data-notifications]::before {
            display: flex;
            justify-content: center;
            align-items: center;
            color: ${colors.white};
            font-weight: 600;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);

            content: attr(data-notifications);
            min-width: 38px;
            height: 18px;
            left: 4px;
            text-align: center;
            font-size: 10px;
            border-radius: 8px;
            z-index: 2;
            background: ${alertColors.textDanger};
        }

        button[data-notifications='0']::before {
            opacity: 0;
        }

        .stats {
            margin: 10px 0 20px;
            padding: 0 20px;

            .text {
                width: 100%;
                display: flex;
                justify-content: space-between;

                span {
                    font-weight: 300;
                    font-size: 14px;
                    text-align: left;
                    color: ${colors.gray};

                    &.percents {
                        font-weight: 700;
                        color: ${colors.white};

                        &::before {
                            content: attr(data-percent);
                        }
                    }
                }
            }

        }
    }

    .hide {
        display: none;
    }

    .state-link {
        display: block;

        i {
            display: inline-block;
            vertical-align: top;
            margin-top: 2px;
        }

        div {
            display: inline-block;
            width: calc(100% - 33px);
        }
    }

    .logo-img {
        width: auto !important;
        height: auto;
        max-width: 140px;
        max-height: 50px;
        display: block;
        margin: 0 auto;
    }

    .text-white {
        color: ${colors.white};
    }

    .badge {
        display: inline-block;
        padding: 0.35em 0.65em;
        font-size: 10px !important;
        font-weight: 600;
        line-height: 1;
        color: ${colors.white};
        text-align: center;
        white-space: nowrap;
        vertical-align: baseline;
        border-radius: 0.25rem;
        border-radius: 50rem;
        background-color: ${altColors.purple};
        text-transform: uppercase;
    }

    .no-child {
        display: none;
    }

    .menu-search {
        position: relative;
        padding: 0 1.5rem;
        display: flex;
        align-items: center;

        label {
            display: none;
        }

        .text-field {
            width: 100%;
        }

        .text-field-clear {
            position: absolute;
            font-size: 1.5rem;
            color: ${colors.gray};
            right: 2rem;
            cursor: pointer;
            outline: none;
            &:hover {
                color: ${colors.gray400};
            }
        }

        > div {
            width: 100%;
        }
    }

    input[type='input'] {
        border: 1px solid ${colors.gray600} !important;
        background: ${colors.gray700} !important;
        color: ${colors.white}; !important;

        &:focus {
            outline: 1px solid ${colors.gray400} !important;
            border: 1px solid ${colors.gray600} !important;
        }
        &::placeholder {
            color: ${colors.gray400} !important;
        }
    }
`;
